"use strict";

import { conf } from "@/config/envConfig";

export const APP_ENV = conf.env;
export const PCS_SERVICE_URL =
  conf.pcsServiceUrl || "https://partner-configuration-ext.qa.ehealthinsurance.com";
export const LOOKER_TERMS_ENDPOINT = "/api/looker-terms";
